<template>
    <header class="header" 
            :class="$store.state.mainFrame && !$store.state.isMenuOpen ? 'header--main' : 'header--second'">

        <div class="header-inner">

            <div class="flex flex--align-center">

                <a href="#" @click="$store.state.mainFrame = true">
                    <div class="logo">
                        <img src="../assets/logo/Logo512x256.svg" class="logo__img" alt="logo" />
                        <p class="logo__title">
                            <span>Longevity</span>
                            <span>InTime</span>
                        </p>
                    </div>
                </a>

                <nav class="nav header__menu">
                    <router-link to="/about" class="button">App</router-link>
                    <router-link to="/about" class="button">About</router-link>
                    <router-link to="/about" class="button">Team</router-link>
                    <router-link to="/about" class="button">VERTICALS</router-link>
                    <router-link to="/about" class="button">CONTACT</router-link>
                </nav>
            </div>

            <button class="button button--switch" 
                    :class="this.$store.state.isMenuOpen ? 'button--close' : 'button--menu'"
                    type="menu"
                    id="open-menu-button"
                    @click="switchMenuStateButton">
            </button>

            <nav class="nav header__control flex">

                <button class="button button--auth accent--gradient"
                        
                        >Login
                </button>
                
                <button class="button button--lang"
                        @click="switchLangBox">En</button>
            </nav>

        </div>
    </header>

</template>

<script>

export default {
    name: 'Header',
    props: [ 'menuState' ],
    data() {
		return {
            isMenuOpen: this.$store.state.isMenuOpen
		}
	},
    methods: {
        switchMenuStateButton (event) {
            this.$store.commit('switchMenuState', !this.$store.state.isMenuOpen)
            
            let body = document.getElementsByTagName('body')[0]

            if (this.$store.state.isMenuOpen && !this.$store.state.isMobile) {
                body.style.overflow = 'hidden'
            } else {
                body.style.overflow = 'unset'
            }
             
        },
        switchLangBox () {
			this.$store.commit('switchLangBox', !this.$store.state.languageBox)
		},
        switchMainFrame () {
			this.$store.commit('switchMainFrame', !this.$store.state.mainFrame)
		}
    }
}
</script>

<style lang="scss" scoped>
@import '../colors.scss';
@import '../mixins.scss';

// make global

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'DM Sans';
}

body {
	margin: 0px!important;
}

.block {
	display: block;
}

.flex {
    display: flex;

    &--align-center {
        align-items: center;
    }
}

.accent {							
	color: $accent;

	&--gradient {
		background: linear-gradient(105.24deg, #3683FC -28.95%, #21355C 260.08%);
		background-clip: text;
		-webkit-text-fill-color: transparent;
	}
}

.dark-blue {
	color: $maastricht-blue;
}

.light-blue {
	color: $light-blue;
}

.indigo {
	color: $indigo;
}

.grey2 {
	color: $grey2;
}

//

.header {
    width: 100%;
    padding: 0 2%;
    // padding-top: 5.7vw;
    padding-top: 2.7vw;
    z-index: 42;
    position: fixed;
    top: 0;
    background-color: #fff;
    height: 8vw;

    @include mobile {
        height: max-content;
        padding: 0;
        padding-top: 6vw;
    }
    
    .header-inner {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__menu {
        @include mobile {
            display: flex;
            position: fixed;
            bottom: 3%;
            background: #CDE0FE;
            box-shadow: 6px 6px 48px rgba(12, 30, 60, 0.1);
            border-radius: 120px;
            padding: 8px 24px;
        }
    }

    &--main {
        padding-left: 7.7%;
        padding-right: 7.7%;
        padding-top: 5.7vw;

        .logo__title {
            display: flex;

            @include mobile {
                display: none;
            }
        }

        .header__menu {
            display: none;

            @include mobile {
                display: flex;
            }
        }
    }

    &--second {

        .header-inner {
            @include mobile {
                padding: 0% 8.8%;
                flex-flow: wrap;
            }
        }

        .logo__title {
            display: none;

            @include mobile {
                display: flex;
            }
        }

        .header__menu {
            display: flex;
        }

        .header__control {
            @include mobile {
                flex-basis: 100%;
                justify-content: space-between;
            }
        }

        .button--switch {
            @include mobile {
                margin-right: 0;
            }
        }
    }
    

    .logo {
        display: flex;

        &__img {
            width: 128px;
            height: 63px;

            @include mobile {
                width: 96px;
                height: 47px;
            }
        }

        &__title {
            // display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin-left: 24px;
            font-size: 24px;
            line-height: 29px;

            &.hide {
                display: none;
            }

            span {
                font-family: 'Inter';

                @include mobile {
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 24px;
                }

                &:last-child {
                    color: $accent;
                }
            }
        }
    }
}


.nav .button {
    margin-right: 64px;
    font-size: 24px;
    line-height: 31px;
    text-transform: uppercase;

    @include mobile {
        margin-right: 6vw;
    }

    &:last-child {
        margin-right: 0;
    }   
}

.button, button {
	border: none;
	background-color: transparent;
	cursor: pointer;
	display: block;

    &--switch {
        margin-left: auto;
        margin-right: 40px;
    }

	&--main {
		font-size: 48px;
		line-height: 62px;
		color: $indigo;
		text-transform: capitalize;
	}

	&--menu {
		width: 36px;
		height: 30px;
		background-image: url('../assets/img/svg/menu-icon.svg');
		background-repeat: no-repeat;
		background-size: contain;

        @include mobile {
            width: 24px;
            height: 20px;
        }
	}

	&--close {
		width: 31px;
		height: 31px;
		background-image: url('../assets/img/svg/close-icon.svg');
		background-repeat: no-repeat;
		background-size: contain;
	}

	&--lang {
		display: flex;
		align-items: center;
		&::after {
			content: '';
			display: block;
			width: 24px;
			height: 24px;
			background-image: url('../assets/img/svg/chevron_down.svg');
			background-repeat: no-repeat;
			margin-left: 9px;
		}

	}
}

nav {
    display: flex;
    padding: 30px;
    align-items: center;

    @include mobile {
        padding: 20px 0;
    }

    a {
        color: $indigo;

        &.router-link-exact-active {
            color: $accent;
        }
    }
}

</style>
